import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BackgroundProcessingNotification from './components/BackgroundProcessingNotification';

function App() {
  return (
    <Router>
      <div className="w-screen p-0">
        <AppRoutes />
        <BackgroundProcessingNotification />
        <ToastContainer style={{ zIndex: 9999 }} />
      </div>
    </Router>
  );
}

export default App;
